import React, { Fragment, useState, useEffect, useRef } from "react";
import Loader from "react-loader-spinner";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import Storage from "../../../services/Storage";
import StudentImportConfirmation from "../../counselor/studentImportConfirmationModal/StudentImportConfirmationModal";
import "./CsvImport.css";
const API_URL = process.env.REACT_APP_API_URL;
const CSVImport = () => {
  const [user] = useState(localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : []);
  const [dataForDownload] = useState([]);
  const [loadingForStudentCsvDownload, setLoadingForStudentCsvDownload] = useState(false);
  const [downloadCSVStudent] = useState(false);
  const [apiCallOrNot] = useState();
  const [selectedFile] = useState();
  const selectedFileRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const [uploadCSVData, setUploadCSVData] = useState();
  const downloadFile = (downloadURL, fileName) => {
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    downloadLink.download = fileName;
    downloadLink.href = downloadURL;
    downloadLink.click();
  };
  const getDataForCSVDownload = _offset => {
    setLoadingForStudentCsvDownload(true);
    GetStudentService.getStudentCountForCSVImport(user?.school_id).then(data => {
      downloadFile(data.data.download);
      setLoadingForStudentCsvDownload(false);
      // setApiCallOrNot(data.data.meta);
      // if (data.data.meta.next !== null) {
      //   data.data.objects.map((item) => {
      //     let obj = {
      //       ...item.student,
      //       ...{ counselor_email: item?.counselor?.email },
      //     };
      //     finalObj.push(obj);
      //   });
      //   setDataForDownload(finalObj);
      // } else if (data.data.meta.next === null) {
      //   data.data.objects.map((item) => {
      //     let obj = {
      //       ...item.student,
      //       ...{ counselor_email: item?.counselor?.email },
      //     };
      //     finalObj.push(obj);
      //   });
      //   setDataForDownload([...dataForDownload, ...finalObj]);
      //   setdownloadCSVStudent(true);
      //   setLoadingForStudentCsvDownload(false);
      // }
    }).catch(_error => {
      setLoadingForStudentCsvDownload(false);
    });
  };
  useEffect(() => {
    if (apiCallOrNot?.next !== null && dataForDownload.length > 0) {
      getDataForCSVDownload(1000);
    }
  }, [apiCallOrNot && dataForDownload && dataForDownload.length > 0]);
  useEffect(() => {
    if (dataForDownload.length > 0) {
      let result_csv = getHeaderRow();
      addStudentsToCsv(result_csv, dataForDownload);
    }
  }, [dataForDownload?.length > 0 && downloadCSVStudent === true]);
  function getHeaderRow() {
    var template = [];
    template.push(['"Student First Name"', '"Student Middle Name"', '"Student Last Name"', '"Student Grade"', '"Student ID"', '"Student Email"', '"Student Mobile"', '"Student DOB"', '"Counselor Emails"']);
    var arr = template;
    var ret = [];
    for (var i = 0, len = arr.length; i < len; i++) {
      var line = [];
      for (var key in arr[i]) {
        if (arr[i].hasOwnProperty(key)) {
          line.push(arr[i][key]);
        }
      }
      ret.push(line.join(","));
    }
    return ret;
  }
  function addStudentsToCsv(csv, students) {
    var studentRecord = [];
    for (var i = 0; i < students.length; i++) {
      studentRecord[0] = students[i].first_name;
      studentRecord[1] = students[i].middle_name;
      studentRecord[2] = students[i].last_name;
      studentRecord[3] = students[i].current_grade;
      studentRecord[4] = students[i].student_id;
      studentRecord[5] = students[i].email;
      studentRecord[6] = students[i].mobile;
      studentRecord[7] = students[i].student_dob;
      studentRecord[8] = students[i].counselor_email;
      var newRow = studentRecord.join(",");
      csv.push(newRow);
    }
    var csvDownload = csv.join("\n");
    var saving = document.createElement("a");
    saving.href = "data:attachment/csv," + encodeURIComponent(csvDownload);
    saving.download = "csv_student_download.csv";
    document.body.appendChild(saving);
    saving.click();
  }
  const uploadFile = () => {
    let formData = new FormData();
    formData.append("school", user?.school_id);
    formData.append("mode", "validation");
    formData.append("csv_file", selectedFile);
    let token = Storage.getTokenInCookie() ? Storage.getTokenInCookie() : "";
    fetch(`${API_URL}/api/v1/admin/upload-csv`, {
      method: "POST",
      headers: {
        "x-authorization": `Bearer ${token}`
      },
      body: formData
    }).then(response => response.json()).then(data => {
      setUploadCSVData(data);
      if (data?.error_csv?.length > 0) {
        setShowModal(true);
      }
    }).catch(_error => {});
  };
  useEffect(() => {
    if (selectedFileRef && selectedFile) {
      uploadFile();
    }
  }, [selectedFile]);
  return <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="csv-export-page">
            <div className="csv-export-header">
              <h1 className="csv-export-title">Export Students Data</h1>
              <p className="csv-export-subtitle">
                Download your school student roster as a CSV file
              </p>
            </div>

            <div className="csv-export-card">
              <div className="csv-export-field">
                <label className="csv-export-label">School</label>
                <div className="csv-export-school">{user?.school_name}</div>
              </div>

              <div className="csv-export-field">
                <label className="csv-export-label">Download Students</label>
                <button type="button" onClick={() => getDataForCSVDownload(0)} disabled={loadingForStudentCsvDownload} className="csv-export-btn">

                  Download
                  {loadingForStudentCsvDownload && <Loader type="TailSpin" color="white" height={15} width={15} />}


                </button>
                <p className="csv-export-hint">
                  Exports student first/last name, grade, ID, email, mobile,
                  DOB, and counselor emails for this school.
                </p>
              </div>
            </div>
          </div>

          {showModal && <StudentImportConfirmation student={uploadCSVData} closeHandler={() => {
          setShowModal(false);
          selectedFileRef.current.value = null;
        }} isOpen={showModal} school_it_ok={true} />}


        </div>
      </div>
    </Fragment>;
};
export default CSVImport;